import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=e0c3b6cc&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0c3b6cc')) {
      api.createRecord('e0c3b6cc', component.options)
    } else {
      api.reload('e0c3b6cc', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=e0c3b6cc&", function () {
      api.rerender('e0c3b6cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2RvuKlSpKx80Z/JS/comp/ImgFallback2.vue"
export default component.exports